import { GridColumnVisibilityModel } from "@mui/x-data-grid-premium";

/**
 * A grid's own defaults with the user's saved preferences on top. Persistence
 * stores only what the user changed, so neither half alone describes the grid
 * the user is looking at.
 */
export function mergeColumnVisibility(
  initial: GridColumnVisibilityModel | undefined,
  persisted: GridColumnVisibilityModel | undefined
): GridColumnVisibilityModel {
  return { ...initial, ...persisted };
}
